const ACTION_ITEMS = {
  PASSPORT: {
    RESULTS: {
      SET: 'PASSPORT_RESULTS_SET',
    },
  },
};

export default ACTION_ITEMS;
